import type { Candle } from "../types";
import type { Swing } from "./types";

export interface Swings { highs: Swing[]; lows: Swing[] }

// Fractal swing detection: a bar whose high/low exceeds `lookback` bars on both sides.
// Ties: the FIRST bar carrying the extreme wins (strict vs earlier bars, non-strict vs later bars). Required for
// synthetic 1s tick candles, where a peak tick price is the close of bar k AND the open of bar k+1.
export const SwingEngine = {
  find(candles: Candle[], lookback = 2): Swings {
    const highs: Swing[] = [], lows: Swing[] = [];
    for (let i = lookback; i < candles.length - lookback; i++) {
      let isHigh = true, isLow = true;
      for (let j = i - lookback; j <= i + lookback; j++) {
        if (j === i) continue;
        if (j < i ? candles[j].high >= candles[i].high : candles[j].high > candles[i].high) isHigh = false;
        if (j < i ? candles[j].low <= candles[i].low : candles[j].low < candles[i].low) isLow = false;
        if (!isHigh && !isLow) break;
      }
      if (isHigh) highs.push({ index: i, price: candles[i].high, time: candles[i].time });
      if (isLow) lows.push({ index: i, price: candles[i].low, time: candles[i].time });
    }
    return { highs, lows };
  },
};
